// Added by Sejune Oh on 2019-02-16
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import ReactDOM from 'react-dom'
import { Provider } from 'mobx-react'
import axios from 'axios'
import './styles/index.css'

// ! Polyfill
import '@webcomponents/webcomponentsjs'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Root component
import RootApp from './RootApp'

// For progressive web app.
import * as serviceWorker from './serviceWorker'

// Root store for states
import { rootStore } from './stores/index'

import AxiosInterceptors from './helper/AxiosInterceptor'
AxiosInterceptors(axios, rootStore)

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Set default api url
axios.defaults.baseURL = (() => {
    let url
    if (process.env.NODE_ENV === 'test') {
        url = process.env.REACT_APP_TEST_URL || ''
    } else {
        url = process.env.REACT_APP_API_URL || ''
    }
    if (url.indexOf('http') !== 0) {
        url = `${window.location.origin}/${url}`
    }
    return url
})()

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
ReactDOM.render(
    <Provider {...rootStore}>
        <RootApp />
    </Provider>,
    document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister()
